import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckCircle2, Clock, FileText, ShieldCheck } from "lucide-react";
import { Icon } from "./Icon";
import { Stack } from "./Stack";
import { Text } from "./Text";
function iconForAction(action) {
    if (action.endsWith(".created"))
        return { icon: FileText, label: "Created" };
    if (action.endsWith(".kyc_validated"))
        return { icon: ShieldCheck, label: "KYC validated" };
    if (action.endsWith(".queued_for_approval"))
        return { icon: Clock, label: "Queued" };
    if (action.endsWith(".approved") || action.endsWith(".transitioned")) {
        return { icon: CheckCircle2, label: "Approved" };
    }
    return { icon: FileText, label: "Event" };
}
function formatTime(iso) {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return iso;
    return d.toLocaleString();
}
function payloadPreview(payload) {
    if (payload === null || payload === undefined)
        return null;
    try {
        return (_jsx(Text, { size: "bodySm", tone: "muted", family: "mono", children: JSON.stringify(payload) }));
    }
    catch {
        return null;
    }
}
const railStyle = {
    position: "relative",
    paddingLeft: 28,
    borderLeft: "1px solid var(--hydrax-color-border)",
    marginLeft: 12,
};
const dotStyle = {
    position: "absolute",
    left: -16,
    top: 4,
    width: 24,
    height: 24,
    borderRadius: "50%",
    background: "var(--hydrax-color-surface)",
    border: "1px solid var(--hydrax-color-border)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "var(--hydrax-color-text-strong)",
};
export function AuditTimeline({ events }) {
    if (events.length === 0) {
        return _jsx(Text, { tone: "muted", children: "No events recorded yet." });
    }
    return (_jsx(Stack, { gap: "lg", children: events.map((e) => {
            const { icon, label } = iconForAction(e.action);
            return (_jsxs("div", { style: railStyle, children: [_jsx("span", { style: dotStyle, "aria-hidden": "true", children: _jsx(Icon, { icon: icon, label: label, size: 12 }) }), _jsxs(Stack, { gap: "xs", children: [_jsx(Text, { family: "mono", children: e.action }), _jsx(Text, { size: "bodySm", tone: "muted", children: formatTime(e.created_at) }), payloadPreview(e.payload)] })] }, e.id));
        }) }));
}
//# sourceMappingURL=AuditTimeline.js.map